import React, { ReactElement } from "react";

interface Props {
  className: string;
}

function NotFound({ className }: Props): ReactElement {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={"100%"}
      height={"100%"}
      viewBox="0 0 510.582 357.286"
    >
      <g
        id="Gruppe_2702"
        data-name="Gruppe 2702"
        transform="translate(-242.48 -238.311)"
      >
        <path
          id="Pfad_157"
          data-name="Pfad 157"
          d="M753.062,416.167c0,116.122-66.879,132.878-198.086,132.878s-312.5,46.788-312.5-69.334,17.561-213.2,148.766-213.2c59.079,0,208.813,11.93,250.378,43.514C692.365,348.583,753.062,352.333,753.062,416.167Z"
          transform="translate(0 37.236)"
          fill="#2d5e30"
          opacity="0.1"
        />
        <path
          id="Pfad_158"
          data-name="Pfad 158"
          d="M361.837,323.824a131.363,131.363,0,0,0,48.143,63.1,131.313,131.313,0,0,0,35.285-36.954,81.953,81.953,0,0,1-83.428-26.149Z"
          transform="translate(157.609 112.918)"
          fill="#729237"
        />
        <g
          id="Gruppe_215"
          data-name="Gruppe 215"
          transform="translate(567.589 462.701)"
        >
          <path
            id="Pfad_159"
            data-name="Pfad 159"
            d="M382.584,372.155a131.278,131.278,0,0,0,35.956-37.144,83.235,83.235,0,0,1-12.886,2.392C397.535,353.631,388.736,366.479,382.584,372.155Z"
            transform="translate(-382.584 -335.011)"
            fill="#5c7f35"
          />
        </g>
        <path
          id="Pfad_160"
          data-name="Pfad 160"
          d="M408.8,399.2a131.431,131.431,0,0,0-11.967-126.51"
          transform="translate(203.827 45.393)"
          fill="none"
          stroke="#729237"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="1"
          strokeDasharray="7"
        />
        <path
          id="Pfad_161"
          data-name="Pfad 161"
          d="M367.224,376.183h0a169.3,169.3,0,0,0,3.959-96.966l-.023.021"
          transform="translate(164.722 54.015)"
          fill="none"
          stroke="#69882c"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="1"
          strokeDasharray="7"
        />
        <g
          id="Gruppe_63"
          data-name="Gruppe 63"
          transform="translate(351.777 337.254)"
        >
          <path
            id="Pfad_26"
            data-name="Pfad 26"
            d="M373.5,361.691a98.564,98.564,0,0,0-41.961-80.741,98.661,98.661,0,0,0,0,161.482A98.568,98.568,0,0,0,373.5,361.691"
            transform="translate(-289.581 -280.95)"
            fill="#75953a"
          />
          <g
            id="Gruppe_216"
            data-name="Gruppe 216"
            transform="translate(41.961 7.885)"
          >
            <path
              id="Pfad_162"
              data-name="Pfad 162"
              d="M317.637,284.492a.523.523,0,0,0-.74.738c14.457,16.267,23.653,40.3,23.653,68.139,0,33.387-22,74.311-32.886,84.577a98.649,98.649,0,0,0,9.973-153.453Z"
              transform="translate(-307.664 -284.348)"
              fill="#5f8238"
            />
          </g>
          <line
            id="Linie_19"
            data-name="Linie 19"
            y2="145.655"
            transform="translate(42.43 34.983)"
            fill="none"
            stroke="#1d1d1b"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="0.5"
          />
          <path
            id="Pfad_163"
            data-name="Pfad 163"
            d="M319.61,351.661s-8.21-9.178-20.638-25.1"
            transform="translate(-277.18 -220.716)"
            fill="none"
            stroke="#1d1d1b"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="0.5"
          />
          <path
            id="Pfad_164"
            data-name="Pfad 164"
            d="M314.649,321.3s-7.794-9.725-11.92-18.248"
            transform="translate(-272.219 -251.761)"
            fill="none"
            stroke="#1d1d1b"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="0.5"
          />
          <path
            id="Pfad_165"
            data-name="Pfad 165"
            d="M307.866,340.894A130.556,130.556,0,0,0,331.117,311.9"
            transform="translate(-265.436 -240.079)"
            fill="none"
            stroke="#1d1d1b"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="0.5"
          />
          <path
            id="Pfad_166"
            data-name="Pfad 166"
            d="M289.581,352.368a98.416,98.416,0,0,0,3.873,27.389,2.8,2.8,0,0,0,5.275.214c11.862-30.1,17.239-65.544,18.807-89a2.8,2.8,0,0,0-4.961-1.926A98.568,98.568,0,0,0,289.581,352.368Z"
            transform="translate(-289.581 -271.627)"
            fill="#5f8238"
          />
        </g>
        <path
          id="Pfad_167"
          data-name="Pfad 167"
          d="M426.034,430.129a81.9,81.9,0,0,1,7.277-102,82.664,82.664,0,0,1,9.915-9.108l.023-.014a169.158,169.158,0,0,0-59.184-79.725,5.014,5.014,0,0,0-5.927,0,168.648,168.648,0,0,0,2.963,273.9,169.487,169.487,0,0,0,57.026-69.143h0A82.332,82.332,0,0,1,426.034,430.129Z"
          transform="translate(88.332 0)"
          fill="#69882c"
        />
        <ellipse
          id="Ellipse_39"
          data-name="Ellipse 39"
          cx="172.915"
          cy="29.631"
          rx="172.915"
          ry="29.631"
          transform="translate(311.215 509.68)"
          fill="#2d5e30"
          opacity="0.1"
        />
        <g
          id="Gruppe_62"
          data-name="Gruppe 62"
          transform="translate(538.977 324.24)"
        >
          <line
            id="Linie_20"
            data-name="Linie 20"
            y2="202.017"
            transform="translate(28.625)"
            fill="none"
            stroke="#fff"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="3"
          />
          <path
            id="Pfad_168"
            data-name="Pfad 168"
            d="M398.879,352.506s-11.389-12.73-28.626-34.807"
            transform="translate(-370.254 -219.41)"
            fill="none"
            stroke="#fff"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="3"
          />
          <path
            id="Pfad_169"
            data-name="Pfad 169"
            d="M396.017,303.372s-14.473-9.454-23.595-18.9"
            transform="translate(-367.391 -263.292)"
            fill="none"
            stroke="#fff"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="3"
          />
          <path
            id="Pfad_170"
            data-name="Pfad 170"
            d="M382.59,337.574c8.862-11.589,5.732-8.228,32.25-40.212"
            transform="translate(-353.965 -246.265)"
            fill="none"
            stroke="#fff"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="3"
          />
        </g>
        <path
          id="Pfad_171"
          data-name="Pfad 171"
          d="M309.374,362.04a168.5,168.5,0,0,0,7.1,48.475C335.728,355.06,348.7,291.9,353.593,248.251A167.983,167.983,0,0,0,309.374,362.04Z"
          transform="translate(88.332 13.125)"
          fill="#53752b"
        />
        <path
          id="Pfad_172"
          data-name="Pfad 172"
          d="M340.285,360.246s17.058-17.278,36.148-44.978"
          transform="translate(129.15 101.62)"
          fill="none"
          stroke="#2d5e30"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="3"
        />
        <path
          id="Pfad_173"
          data-name="Pfad 173"
          d="M340.285,293.871s17.383-11.352,28.338-22.706"
          transform="translate(129.15 43.383)"
          fill="none"
          stroke="#2d5e30"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="3"
        />
        <path
          id="Pfad_174"
          data-name="Pfad 174"
          d="M362.325,332.545s-15.536-20.318-38.731-48.294"
          transform="translate(107.11 60.663)"
          fill="none"
          stroke="#2d5e30"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="3"
        />
        <path
          id="Pfad_175"
          data-name="Pfad 175"
          d="M420.509,271.474c-.886-.937-1.757-1.889-2.671-2.8a24.537,24.537,0,0,0-34.858,0,131.461,131.461,0,0,0-13.9,16.429,81.547,81.547,0,0,1,45.6-13.856C416.643,271.244,418.581,271.337,420.509,271.474Z"
          transform="translate(167.18 30.495)"
          fill="#729237"
        />
        <path
          id="Pfad_176"
          data-name="Pfad 176"
          d="M367.224,386.311a68.238,68.238,0,1,0,3.936-96.945,168.921,168.921,0,0,1-3.936,96.945Z"
          transform="translate(164.722 43.887)"
          fill="none"
        />
        <path
          id="Pfad_177"
          data-name="Pfad 177"
          d="M387.306,304.745a168.373,168.373,0,0,0-32.15-54.928,1.934,1.934,0,0,0-3.068,2.348c11.774,17.32,20.55,38.256,25.3,61.688A82.667,82.667,0,0,1,387.306,304.745Z"
          transform="translate(144.253 14.275)"
          fill="#53752b"
        />
        <path
          id="Pfad_178"
          data-name="Pfad 178"
          d="M385.216,320.974c-12.6,37.9-32.8,71.617-44.931,83.057a169.487,169.487,0,0,0,57.026-69.143A82.326,82.326,0,0,1,385.216,320.974Z"
          transform="translate(129.15 109.155)"
          fill="#53752b"
        />
        <path
          id="Pfad_179"
          data-name="Pfad 179"
          d="M367.224,386.311a68.238,68.238,0,1,0,3.959-96.966,169.3,169.3,0,0,1-3.959,96.966Z"
          transform="translate(164.722 43.887)"
          fill="none"
        />
        <line
          id="Linie_21"
          data-name="Linie 21"
          y2="264.568"
          transform="translate(469.435 289.294)"
          fill="none"
          stroke="#2d5e30"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="3"
        />
        <g
          id="Gruppe_220"
          data-name="Gruppe 220"
          transform="translate(498.259 300.082)"
        >
          <path
            id="Pfad_180"
            data-name="Pfad 180"
            d="M517.943,420.049l-93.905-93.905a7.015,7.015,0,0,0-9.8,0h0a6.935,6.935,0,0,0,0,9.8l93.905,93.905a6.931,6.931,0,0,0,9.8,0c.114-.114.195-.246.3-.367A6.914,6.914,0,0,0,517.943,420.049Z"
            transform="translate(-274.141 -186.77)"
            fill="#459a9e"
          />
          <path
            id="Pfad_181"
            data-name="Pfad 181"
            d="M518.635,345.873a82.95,82.95,0,0,0-74.466-80.449,83.812,83.812,0,0,0-8.437-.425,82.956,82.956,0,1,0,82.955,82.955C518.686,347.256,518.651,346.567,518.635,345.873ZM458.2,413.288a69.089,69.089,0,1,1,46.621-65.333A68.913,68.913,0,0,1,458.2,413.288Z"
            transform="translate(-352.615 -264.84)"
            fill="#459a9e"
          />
          <g
            id="Gruppe_217"
            data-name="Gruppe 217"
            transform="translate(147.217 138.586)"
          >
            <path
              id="Pfad_182"
              data-name="Pfad 182"
              d="M512.734,419.346l-93.905-93.905a7,7,0,0,0-.963-.787,6.909,6.909,0,0,0,.3,9.437L512.071,428a7,7,0,0,0,.963.787A6.914,6.914,0,0,0,512.734,419.346Z"
              transform="translate(-416.149 -324.654)"
              fill="#48aadd"
            />
          </g>
          <g id="Gruppe_219" data-name="Gruppe 219" transform="translate(0 0)">
            <circle
              id="Ellipse_40"
              data-name="Ellipse 40"
              cx="69.09"
              cy="69.09"
              r="69.09"
              transform="translate(0 31.747) rotate(-13.283)"
              fill="none"
            />
            <g
              id="Gruppe_218"
              data-name="Gruppe 218"
              transform="translate(11.331 59.154)"
            >
              <path
                id="Pfad_183"
                data-name="Pfad 183"
                d="M360.285,314.384a69,69,0,0,1,4.272-23.961c-12.772,22.395-7.846,53.462,13.635,74.945,21.07,21.07,51.366,26.217,73.652,14.35a69.087,69.087,0,0,1-91.559-65.333Z"
                transform="translate(-357.589 -290.423)"
                fill="#48aadd"
              />
            </g>
            <path
              id="Pfad_184"
              data-name="Pfad 184"
              d="M466.625,345.632a82.946,82.946,0,0,0-74.464-80.449,134.242,134.242,0,0,1,42.128,28.73A131.724,131.724,0,0,1,466.625,345.632Z"
              transform="translate(-300.608 -264.598)"
              fill="#48aadd"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default NotFound;
